import { useCallback, useEffect, useMemo, useState } from "react";
import adminApi from "../api/adminApi";
import { isSameData } from "../utils/adminUtils";
import { summariseSessions } from "../utils/sessions";
import { POLL_MS } from "../constants/adminConstants";

export default function useSessions(setBanner) {
  const [sessions, setSessions] = useState([]);
  const [sessionsLoading, setSessionsLoading] = useState(false);

  const loadSessions = useCallback(async (silent = false) => {
    if (!silent) setSessionsLoading(true);

    try {
      const data = await adminApi.getSessions();
      const next = Array.isArray(data) ? data : [];
      setSessions((prev) => (isSameData(prev, next) ? prev : next));
    } catch (error) {
      setBanner({ type: "error", text: error.message || "Failed to load sessions" });
    } finally {
      if (!silent) setSessionsLoading(false);
    }
  }, [setBanner]);

  useEffect(() => {
    const timer = setInterval(() => {
      loadSessions(true);
    }, POLL_MS);

    return () => clearInterval(timer);
  }, [loadSessions]);

  const sessionSummary = useMemo(() => summariseSessions(sessions), [sessions]);

  return {
    sessions,
    sessionsLoading,
    sessionSummary,
    loadSessions,
  };
}